import { createSlice } from '@reduxjs/toolkit';
import { SLICE_NAME } from 'constants/common';

const initialState = {
    defaultConfig: null,
    initialConfig: null,
    draftConfig: null,
    status: 'idle',
    isVMPTheme: true,
};

export const themeSlice = createSlice({
    name: SLICE_NAME.THEME,
    initialState,
    reducers: {
        setConfigs(state, action) {
            const { defaultConfig, initialConfig } = action.payload;
            state.defaultConfig = defaultConfig;
            state.initialConfig = initialConfig;
            state.draftConfig = { ...initialConfig };
        },
        updateDraft(state, action) {
            const { key, value } = action.payload;
            state.draftConfig[key] = value;
        },
        resetToDefaultTheme(state) {
            state.draftConfig = { ...state.defaultConfig };
        },
        cancelChangeTheme(state) {
            state.draftConfig = { ...state.initialConfig };
        },
        saveTheme(state) {
            state.initialConfig = { ...state.draftConfig };
        },
    },
});

export const { setConfigs, updateDraft, resetToDefaultTheme, cancelChangeTheme, saveTheme } = themeSlice.actions;

export default themeSlice.reducer;
